<template>
    <div class="container pb-4">

<div class="row py-4">
    <div class="col text-center">
        <a :href="`/returns`"><i class="fa-solid fa-arrow-left pr-1"></i>Back to returns</a>
    </div>
</div>

  <div class="row">

    <div class="col-md-9 pr-md-0">
        <div class="card mb-3">
        <div class="card-body">

          <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>
          <div v-else>

            <div v-if="item">
              <div class="mb-3 text-center alert alert-success py-2" v-if="shippingInfo && shippingInfo.estimated_delivery">Estimated delivery {{formatDateSimple(shippingInfo.estimated_delivery)}}</div>
                <div class="pb-3 text-center">
                    <div v-if="item.product.images">
                      <a :href="makeProductLink(item.product)" target="_blank" title="View product">
                        <img v-if="item.product.images.length > 0" :src="item.product.images[0].url" style="height:4rem;" />
                        <img v-else src="/images/image-not-found.svg" style="height:4rem;" />
                      </a>
                      </div>
                    <div class="mt-2"><b>{{item.product.name}}</b></div>
                    <div>R {{item.product.price*item.quantity}} &bull; Qty {{item.quantity}} &bull; {{item.reason.name}}</div>
                </div>   
            </div>

            <div v-if="loadingUpdates" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>

            <div v-else-if="updates.length == 0" class="text-center">
                <div class="alert alert-warning py-1 mb-0"><i class="far fa-clock mr-2"></i>No shipping updates yet</div>
            </div>

            <table v-else class="table" style="line-height:1.3rem;">
                <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Status</th>
                  <th class="first-right pl-3">Updated</th>
                </tr>
              </thead>
                <tbody>
                    <tr v-for="(update, index) in updates" :key="index">
                        <td class="pl-3">{{formatName(update.status.name)}}</td>
                        <td class="pl-3"><timeago
                        :datetime="update.created_at"
                        :auto-update="60"
                        :title="formatDateMoment(update.created_at)"></timeago>
                        </td>
                    </tr>
                </tbody>
                </table>

        </div>
        </div>
        </div>
    </div>

    <div class="col-md-3 text-center" v-if="item">
        <div class="card" v-if="item.shipping_label">
            <div class="card-body">
                <a :href="item.shipping_label" target="_blank"><i class="fas fa-plus-circle mr-2"></i>Download shipping label</a>
            </div>
        </div>
        <!-- <div class="card mt-3" v-if="item.shipping_sticker">
            <div class="card-body">
                <a :href="item.shipping_sticker" target="_blank"><i class="fas fa-plus-circle mr-2"></i>Download shipping sticker</a>
            </div>
        </div> -->
    </div>

    </div>

</div>

</template> 

<script>
export default {
 props: ['id'],

  data() {
    return {
      order: {},
      item: null,
      updates: [],
      loading: false,
      loadingUpdates: false,
      shippingInfo: null
    };
  },

  created() {
    this.getUpdates();
    this.getProduct();
    this.getShippingInfo();
  },

  methods: {

    getProduct() {
      this.loading = true;
      axios
        .get('/returns/get/'+this.id)
        .then((response) => {
          this.item = response.data;
          this.loading = false;
        });
    },

    getShippingInfo() {
      axios
        .get('/dashboard/shipping-info/'+this.order_product_id)
        .then((response) => {
          this.shippingInfo = response.data;
        });
    },

    getUpdates() {
      this.loadingUpdates = true;
      axios.get(`/dashboard/${this.id}/updates`).
      then((response) => {
        this.updates = response.data;
        this.loadingUpdates = false;
      });
    },

  },
};
</script>